module.exports = __webpack_public_path__ + "static/img/19.85c12b7e.png";